import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

const MODES = [
  {
    id: "alliance",
    name: "Alliance",
    accent: "#1E3A8A",
    image: "https://static.prod-images.emergentagent.com/jobs/4aedbd9c-cc9b-4c85-b42d-35c258d0324d/images/3b85e3cb688cd1725e4f296189abed5413913ae13d294c662b26dba6b8c96ff6.jpeg",
    description: "One shared Master Map, split into a Branch per General — your Master GM oversees everyone and can even run their own Branch alongside the table. Play tightly coordinated as one big party, or let each General find their own path at their own pace — it's up to you.",
  },
  {
    id: "tournament",
    name: "Tournament",
    accent: "#D4AF37",
    image: "https://static.prod-images.emergentagent.com/jobs/4aedbd9c-cc9b-4c85-b42d-35c258d0324d/images/2d2101a60042bc4a1cdd2853c989e9b5c73f686e7560c3ffde1bb83976163315.jpeg",
    description: "Your Master GM sets up identical Branches and referees a score-based, single-elimination bracket. Outlast every rival party to be crowned champion.",
  },
  {
    id: "bbebbeg",
    name: "BBEBBEG",
    accent: "#D90429",
    image: "https://static.prod-images.emergentagent.com/jobs/4aedbd9c-cc9b-4c85-b42d-35c258d0324d/images/b295126aef090b9e598034c5e63baf72813c771348fbca05927d55b4d3883d0b.jpeg",
    description: "A world-ending threat has risen. Every General's party travels from far-flung lands — across as many maps as your Master GM builds — to end your adventure on ONE shared area: a final 1-vs-100 stand where every General fights alongside you as a co-GM.",
  },
  {
    id: "dungeon_crawl",
    name: "Dungeon Crawl",
    accent: "#B45309",
    image: "https://static.prod-images.emergentagent.com/jobs/4aedbd9c-cc9b-4c85-b42d-35c258d0324d/images/8813798dbdba7311160369a9ec0a4c949cb4c87df58c7f36844fee7721b8766b.jpeg",
    description: "Race through competing Master GM-built dungeons. Score points for survivors (or a lack thereof), treasure gathered, or speed — your Master GM's call.",
  },
];

export function RaidModePickerModal({ open, onOpenChange, onSelect }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#151613] border-white/10 text-[#f1e0c5] max-w-3xl p-0 overflow-hidden" data-testid="raid-mode-picker-modal">
        <DialogHeader className="p-6 md:p-8 pb-2 bg-gradient-to-b from-[#2A211D] to-[#151613]">
          <DialogTitle className="font-display text-3xl md:text-4xl text-center text-[#D4AF37]">Choose Your Raid Mode</DialogTitle>
          <DialogDescription className="text-center text-[#f1e0c5]/50">Every mode plays very differently — pick the story you want to tell.</DialogDescription>
          <p className="text-center text-sm text-[#D4AF37]/80 pt-1" data-testid="raid-mode-picker-structure-note">
            One Master GM to puppet them all.<br />Up to 10 Generals (GMs) that can have up to 10 players each.
          </p>
        </DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 p-6 md:p-8 pt-4 max-h-[70vh] overflow-y-auto scrollbar-thin">
          {MODES.map((m) => (
            <div
              key={m.id}
              role="button"
              tabIndex={0}
              data-testid={`raid-mode-card-${m.id}`}
              onClick={() => onSelect(m.id)}
              onKeyDown={(e) => e.key === "Enter" && onSelect(m.id)}
              className="group flex flex-col rounded-xl overflow-hidden bg-black/30 border border-white/10 cursor-pointer transition-all duration-300 hover:-translate-y-1 focus:outline-none"
              style={{ "--accent": m.accent }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = m.accent; e.currentTarget.style.boxShadow = `0 0 30px ${m.accent}33`; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = ""; e.currentTarget.style.boxShadow = ""; }}
            >
              <div className="h-32 md:h-36 overflow-hidden relative">
                <img src={m.image} alt={m.name} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#151613] via-transparent to-transparent" />
              </div>
              <div className="p-4 flex flex-col gap-1.5 flex-1">
                <h3 className="font-display text-lg" style={{ color: m.accent }}>{m.name}</h3>
                <p className="text-xs text-[#f1e0c5]/60 leading-relaxed">{m.description}</p>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
